import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DialogLayoutDisplay } from '@costlydeveloper/ngx-awesome-popup';
import { ResourceService } from '@direction/translate';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MenuService } from '../../services/menu.service';
import { TurnstileService } from '../../services/turnstile.service';

@Component({
  selector: 'ds-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {
  notifications: any[] = [];
  notificationType: string = 'warning';
  isServerOnline: boolean = true;
  dateLastWatchdog!: string;
  componentApplicationName: string = '';
  constructor(
    private menuService: MenuService,
    private router: Router,
    public turnstileService: TurnstileService,
    private resource: ResourceService,
    private helpersService: HelpersService
  ) {
    this.componentApplicationName = localStorage.getItem('titleApplication') ? localStorage.getItem('titleApplication') : '';
    this.menuService
      .getApplicationTitle()
      .pipe()
      .subscribe((applicationTitle) => {
        if (applicationTitle) this.componentApplicationName = applicationTitle;
      });
    this.turnstileService.statusServer().subscribe((data) => {
      if (this.isServerOnline && !data.sucess) {
        this.notifications.push({
          description: this.resource.getResource('@direction.ui.navbar.notification.offline'),
          type: 'danger',
          time: new Date(Date.now()).toLocaleString('pt-BR')
        });
        this.notificationType = 'danger';
        this.isServerOnline = false;
      }
      if (data.sucess) {
        this.notifications = [];
        this.isServerOnline = true;
      }
    });

    this.turnstileService.closeEventsSubject$.subscribe((data) => {
      if (data.sucess) {
        this.notifications = [];
        this.isServerOnline = true;
      }
    });

    this.turnstileService.eventWatchdog$.subscribe((data) => {
      this.dateLastWatchdog = data.date;
    });
  }

  showLastWatchdog() {
    this.helpersService.showToast(
      DialogLayoutDisplay.INFO,
      this.resource.getResource('@direction.ui.navbar.watchdog'),
      this.dateLastWatchdog
    );
  }
}
